import { atom } from "jotai";

export const referenceMeasurementIDToDeleteAtom = atom<string | null>(null);
